import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'

export default function Checkout() {
  const navigate = useNavigate()
  const [paymentMethod, setPaymentMethod] = useState<'pix' | 'credit'>('credit')

  const handlePayment = () => {
    // Simulação de pagamento - em produção, integrar com gateway real
    navigate('/obrigado')
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50 py-12 px-4">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-4xl mx-auto"
      >
        <div className="grid md:grid-cols-2 gap-8">
          {/* Resumo do Produto */}
          <div className="bg-white rounded-3xl shadow-xl p-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">
              Resumo do Pedido
            </h2>
            
            <div className="border-b border-gray-200 pb-6 mb-6">
              <h3 className="text-lg font-semibold text-gray-700 mb-2">
                Mapa Individual dos 4 Elementos + Método Eleve e Prospere
              </h3>
              <ul className="space-y-2 text-gray-600 text-sm">
                <li>✓ Mapa Individual de Bloqueios</li>
                <li>✓ Identificação de crenças ativas</li>
                <li>✓ Área mais impactada</li>
                <li>✓ Plano prático de reequilíbrio</li>
                <li>✓ Protocolo guiado</li>
                <li>✓ Acesso completo ao Método</li>
              </ul>
            </div>

            <div className="space-y-3">
              <div className="flex justify-between text-gray-700">
                <span>Subtotal:</span>
                <span>R$ 147,00</span>
              </div>
              <div className="flex justify-between text-2xl font-bold text-gray-800 pt-3 border-t border-gray-200">
                <span>Total:</span>
                <span>R$ 147,00</span>
              </div>
              <p className="text-sm text-gray-500 text-center pt-2">
                ou 12x de R$ 15,20
              </p>
            </div>

            <div className="mt-6 bg-green-50 border-2 border-green-200 rounded-xl p-4">
              <p className="text-green-800 text-sm text-center font-medium">
                🛡️ Garantia incondicional de 7 dias
              </p>
            </div>
          </div>

          {/* Formulário de Pagamento */}
          <div className="bg-white rounded-3xl shadow-xl p-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">
              Pagamento
            </h2>

            <div className="mb-6">
              <label className="block text-gray-700 font-medium mb-3">
                Forma de Pagamento
              </label>
              <div className="grid grid-cols-2 gap-4">
                <button
                  onClick={() => setPaymentMethod('credit')}
                  className={`py-3 px-4 rounded-xl font-medium transition-all ${
                    paymentMethod === 'credit'
                      ? 'bg-indigo-600 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  💳 Cartão
                </button>
                <button
                  onClick={() => setPaymentMethod('pix')}
                  className={`py-3 px-4 rounded-xl font-medium transition-all ${
                    paymentMethod === 'pix'
                      ? 'bg-indigo-600 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  📱 PIX
                </button>
              </div>
            </div>

            {paymentMethod === 'credit' && (
              <div className="space-y-4">
                <div>
                  <label className="block text-gray-700 font-medium mb-2">
                    Número do Cartão
                  </label>
                  <input
                    type="text"
                    placeholder="0000 0000 0000 0000"
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-indigo-500 focus:outline-none"
                  />
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      Validade
                    </label>
                    <input
                      type="text"
                      placeholder="MM/AA"
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-indigo-500 focus:outline-none"
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      CVV
                    </label>
                    <input
                      type="text"
                      placeholder="123"
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-indigo-500 focus:outline-none"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-gray-700 font-medium mb-2">
                    Nome no Cartão
                  </label>
                  <input
                    type="text"
                    placeholder="Nome como está no cartão"
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-indigo-500 focus:outline-none"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-medium mb-2">
                    Parcelas
                  </label>
                  <select className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-indigo-500 focus:outline-none">
                    <option>1x de R$ 147,00 sem juros</option>
                    <option>2x de R$ 48,50 sem juros</option>
                    <option>3x de R$ 32,33 sem juros</option>
                    <option>12x de R$ 15,20 sem juros</option>
                  </select>
                </div>
              </div>
            )}

            {paymentMethod === 'pix' && (
              <div className="text-center py-8">
                <div className="bg-gray-100 rounded-xl p-8 mb-4">
                  <p className="text-gray-700 mb-4">
                    QR Code do PIX aparecerá aqui após confirmar
                  </p>
                  <div className="w-48 h-48 bg-white border-2 border-gray-300 rounded-xl mx-auto flex items-center justify-center">
                    <span className="text-6xl">📱</span>
                  </div>
                </div>
                <p className="text-sm text-gray-600">
                  Pagamento instantâneo via PIX
                </p>
              </div>
            )}

            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={handlePayment}
              className="w-full bg-gradient-to-r from-green-600 to-emerald-600 text-white text-lg font-bold py-4 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 mt-6"
            >
              CONFIRMAR PAGAMENTO
            </motion.button>

            <p className="text-xs text-gray-500 text-center mt-4">
              🔒 Pagamento 100% seguro e criptografado
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  )
}
